import { useEffect, useRef } from 'react';

import { appendProtocol } from '@/postContentElement/components/utils/link';
import { usePostContentContext } from '@/postContentElement/context';
import { evaluateAndAppendUTMParams } from '@/utils/evaluateAndAppendUTMParams';

interface Props {
  anchorId?: string;
  oembedHtml?: string;
  threadPostUri?: string;
  threadPostCid?: string;
  threadContent?: string;
  threadUrl?: string;
  profileName?: string;
  profileUsername?: string;
  postedAt?: string;
}

const BlueSky = ({
  anchorId,
  oembedHtml,
  threadPostUri,
  threadPostCid,
  threadContent,
  threadUrl,
  profileName,
  profileUsername,
  postedAt,
}: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const isHydrated = useRef(false);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || !oembedHtml || isHydrated.current) return;
    container.innerHTML = oembedHtml;

    // biome-ignore lint/suspicious/noExplicitAny: third-party global
    (window as any)?.bluesky?.scan?.(container);
    isHydrated.current = true;
  }, [oembedHtml]);

  if (oembedHtml) {
    return <div ref={containerRef} className="bluesky-wrapper max-w-[520px] mx-auto" id={anchorId} />;
  }

  const { utmParams } = usePostContentContext();
  const threadUrlWithUTMParams = evaluateAndAppendUTMParams(appendProtocol(threadUrl), utmParams);

  return (
    <div className="bluesky-wrapper max-w-[520px] mx-auto" id={anchorId}>
      <blockquote
        className="bluesky-embed text-center"
        data-bluesky-uri={threadPostUri}
        data-bluesky-cid={threadPostCid}
      >
        <p dir="ltr" lang="en">
          {threadContent}
        </p>
        <a href={threadUrlWithUTMParams}>
          <p>
            &mdash;
            {profileName}({profileUsername})
            <br />
            {postedAt}
          </p>
        </a>
      </blockquote>
    </div>
  );
};

export { BlueSky };
